import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import { persistReducer,persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import registerSlice from './user/registerSlice';
import RoleAccessSlice from './role_access/role_access'
import IndividualroleSlice from './individual_role/Individual_role'

const rootReducer = combineReducers({
  user: userReducer,
  register: registerSlice,
  roles: RoleAccessSlice,
  Individual: IndividualroleSlice
});

const persistConfig = {
  key: 'root',
  storage,
  version: 1,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);